/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { createContext, useEffect, useState, useRef } from "react";

export const accrpArchivalsContext = createContext([]);

export default function ACCRPArchivalsContext({ children }) {
  const [accrpArchivals, setAccrpArchivals] = useState(null);
  //const heritageSitesRef = useRef(null);
  //heritageSitesRef.current = heritageSites;
  const [loading, setLoading] = useState(false);

  const getAccrpArchivals = async () => {
    try {
      const result = await axios.get(
        `https://api.alachuacounty.us/truth-rec-backend/api/getResources`
      );
      return result;
    } catch (error) {
      console.log({ error });
      setLoading(false);
      return [];
    }
  };

  const initialLoad = async () => {
    const result = await getAccrpArchivals();

    setAccrpArchivals(result.data);
    setLoading(true);
   /*  console.log("accrp archivals in context load:: ");
    console.log(result.data); */
  };

  useEffect(() => {
    initialLoad();
  }, []);

  return (
    <accrpArchivalsContext.Provider value={{ accrpArchivals, loading }}>
      {children}
    </accrpArchivalsContext.Provider>
  );
}
